import React from 'react';
import Icon from '../Icon';

export interface AlertProps {
  type: 'error' | 'success' | 'warning' | 'info';
  title?: string;
  message?: string;
  messages?: string[];
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ type, title, message, messages, className = '' }) => {
  const getAlertStyles = () => {
    switch (type) {
      case 'error':
        return {
          container: 'bg-red-50 border-red-200',
          icon: 'text-red-400',
          title: 'text-red-800',
          message: 'text-red-700',
        };
      case 'success':
        return {
          container: 'bg-green-50 border-green-200',
          icon: 'text-green-400',
          title: 'text-green-800',
          message: 'text-green-800',
        };
      case 'warning':
        return {
          container: 'bg-yellow-50 border-yellow-200',
          icon: 'text-yellow-400',
          title: 'text-yellow-800',
          message: 'text-yellow-700',
        };
      case 'info':
        return {
          container: 'bg-blue-50 border-blue-200',
          icon: 'text-blue-400',
          title: 'text-blue-800',
          message: 'text-blue-700',
        };
    }
  };

  const getIconType = () => {
    switch (type) {
      case 'error':
        return 'error';
      case 'success':
        return 'check';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
    }
  };

  const styles = getAlertStyles();
  const iconType = getIconType();

  return (
    <div role="alert" className={`p-4 ${styles.container} border rounded-lg ${className}`}>
      <div className="flex">
        <Icon 
          type={iconType} 
          color={styles.icon} 
          className="mr-2 mt-0.5" 
        />
        <div className="flex-1">
          {title && (
            <h3 className={`text-sm font-medium ${styles.title}`}>{title}</h3>
          )}
          {message && (
            <p className={`${title ? 'mt-1' : ''} text-sm ${styles.message}`}>{message}</p>
          )}
          {messages && messages.length > 0 && (
            <div className={`${title ? 'mt-2' : ''} text-sm ${styles.message}`}>
              <ul className="list-disc list-inside space-y-1">
                {messages.map((msg, index) => (
                  <li key={index}>{msg}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alert;